import { render, staticRenderFns } from "./DrawerPermission.vue?vue&type=template&id=0855127e&"
import script from "./DrawerPermission.vue?vue&type=script&lang=js&"
export * from "./DrawerPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports